import moment from "moment";

const participationTypeList = {
  202209: "Combine Invite",
  202221: "Elite Camp Invite",
  202222: "G League Ignite",
  202211: "Basketball Africa League",
  202309: "Combine Invite",
  202321: "Elite Camp Invite",
  202322: "G League Ignite",
  202311: "Basketball Africa League",
  202409: "Combine Invite",
  202421: "Elite Camp Invite",
  202422: "G League Ignite",
  202411: "Basketball Africa League",
};

const highSchoolEventConst = [
  "McDonalds All America",
  "Hoop Summit",
  "Jordan Brand Classic",
  "Test",
];

const rankingsConst = ["247", "ESPN", "Rivals", "RSCI"];
export const exportPlayerProfileDetails = (
  playerData,
  lengthUnits,
  weightUnits,
  getWeightUnitValue,
  getLengthUnitValue,
  getWeightUnitLabelType
) => {
  const getRawHighSchoolEventsData = () => {
    const highSchoolEventsDataArray = highSchoolEventConst.map((eventName) => ({
      eventName,
      eventYear: "",
    }));

    playerData.highSchoolEvents.forEach((record) => {
      const { hsEventId, eventYear } = record;
      const index = hsEventId - 1;
      if (highSchoolEventsDataArray[index]) {
        highSchoolEventsDataArray[index].eventYear = eventYear || "--";
      }
    });

    return highSchoolEventsDataArray;
  };

  const getRawRankigEventsData = () => {
    const rankingsDataArray = [];

    rankingsConst.forEach((eventName, i) => {
      rankingsDataArray.push({ eventName, ranking: "--" });
    });

    playerData.ranking.forEach((record) => {
      const index = record.rankItemId - 1;
      if (rankingsDataArray[index]) {
        rankingsDataArray[index].ranking = record.rankNumber || "--";
      }
    });

    return rankingsDataArray;
  };

  const styleHeaderCss = {
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "e6eefb" },
    },
    font: { sz: "11", bold: true, color: { argb: "1d428a" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    alignment: {
      wrapText: true,
      horizontal: "center",
      vertical: "top",
    },
  };

  const combineDetails = {
    title: "Combine Details",
    headerNames: [
      { title: "Participation Type", width: 30, style: styleHeaderCss },
      { title: "Jersey Number", width: 30, style: styleHeaderCss },
    ],
    data:
      playerData?.participate?.map((record) => ({
        eventType: participationTypeList[parseInt(record.eventId)] || "--",
        jersey: record.jersey?.toString() ?? "--",
      })) || [],
    columnStyles: Array(2).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const playerDetails = {
    title: "",
    headerNames: [
      { title: "Date of Birth", width: 30, style: styleHeaderCss },
      { title: "Twitter", width: 30, style: styleHeaderCss },
      { title: "Instagram", width: 20, style: styleHeaderCss },
      { title: "Height", width: 20, style: styleHeaderCss },
      { title: "Position", width: 20, style: styleHeaderCss },
      { title: "Weight", width: 20, style: styleHeaderCss },
      { title: "Residence", width: 20, style: styleHeaderCss },
    ],
    data: [
      {
        dob: playerData?.dob
          ? moment(playerData.dob).format("MM/DD/YYYY")
          : "--",
        twitter: playerData?.twitter || "--",
        instagram: playerData?.instagram || "--",
        heightInFeet: playerData?.heightInFeet
          ? `${getLengthUnitValue(
              playerData.heightInFeet,
              playerData.heightInInches
            )}`
          : "--",
        positionName: playerData?.positionName || "--",
        weight: playerData?.weight
          ? `${getWeightUnitValue(playerData.weight)} ${getWeightUnitLabelType(
              weightUnits
            )}`
          : "--",
        address1: playerData?.address1 || "--",
      },
    ],
    columnStyles: Array(7).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const agentDetails = {
    title: "Agent Details",
    headerNames: [
      { title: "Agency Name/Agent", width: 30, style: styleHeaderCss },
      { title: "Agent Phone", width: 30, style: styleHeaderCss },
      { title: "Agent Email", width: 20, style: styleHeaderCss },
    ],
    data:
      playerData?.agent?.map((record) => ({
        name: record.name?.toString() || "--",
        phone: record.phone?.toString() || "--",
        email: record.email?.toString() || "--",
      })) || [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const collegeExprienceDetails = {
    title: "College Experience",
    headerNames: [
      {
        title: "College Class",
        field: "classTypeName",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "College Year",
        field: "years",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "College",
        field: "collegeName",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "College Conference",
        field: "conferenceName",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "College Contact",
        field: "contact",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "College Contact Phone",
        field: "phone",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "College Contact Email",
        field: "email",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      playerData && playerData?.college.length > 0
        ? playerData.college.map((record) => {
            return {
              classTypeName: record.classTypeName
                ? record.classTypeName.toString()
                : "--",
              years: record.years ? record.years.toString() : "--",
              collegeName: record.collegeName
                ? record.collegeName.toString()
                : "--",
              conferenceName: record.conferenceName
                ? record.conferenceName.toString()
                : "--",
              contact: record.contact ? record.contact.toString() : "--",
              phone: record.phone ? record.phone.toString() : "--",
              email: record.email ? record.email.toString() : "--",
            };
          })
        : [],
    columnStyles: Array(7).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const highSchoolDetails = {
    title: "High School Details",
    headerNames: [
      {
        title: "High School Year",
        field: "years",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "High School",
        field: "schoolName",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "High School Town/City",
        field: "townOrCity",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "High School State",
        field: "state",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "High School Contact",
        field: "contact",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "High School Contact Phone",
        field: "phone",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "High School Contact Email",
        field: "email",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      playerData && playerData?.highSchool?.length > 0
        ? playerData.highSchool.map((record) => {
            return {
              years: record.years ? record.years.toString() : "--",
              schoolName: record.schoolName
                ? record.schoolName.toString()
                : "--",
              townOrCity: record.townOrCity
                ? record.townOrCity.toString()
                : "--",
              state: record.state ? record.state.toString() : "--",
              contact: record.contact ? record.contact.toString() : "--",
              phone: record.phone ? record.phone.toString() : "--",
              email: record.email ? record.email.toString() : "--",
            };
          })
        : [],
    columnStyles: Array(7).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const aIUClubProgramDetails = {
    title: "AAU/Club Programs",
    headerNames: [
      {
        title: "AAU/Club Location",
        field: "location",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "AAU Circuit",
        field: "circuit",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "AAU/Club Programs",
        field: "programs",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "AAU/Club Programs Contact",
        field: "programsContact",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "AAU/Club Programs Contact Phone",
        field: "programsPhone",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "AAU/Club Programs Contact Email",
        field: "programsEmail",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      playerData && playerData?.aauClub?.length > 0
        ? playerData.aauClub.map((record) => {
            return {
              location: record.location ? record.location.toString() : "--",
              circuit: record.circuit ? record.circuit.toString() : "--",
              programs: record.programs ? record.programs.toString() : "--",
              programsContact: record.programsContact
                ? record.programsContact.toString()
                : "--",
              programsPhone: record.programsPhone
                ? record.programsPhone.toString()
                : "--",
              programsEmail: record.programsEmail
                ? record.programsEmail.toString()
                : "--",
            };
          })
        : [],
    columnStyles: Array(6).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const internationalExprienceDetails = {
    title: "International/Professional Experience",
    headerNames: [
      {
        title: "Club Year",
        field: "years",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Country of Club",
        field: "countryName",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "League",
        field: "league",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Club",
        field: "clubName",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Club Contact",
        field: "contact",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Club Contact Phone",
        field: "phone",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      playerData && playerData?.intProfExperience?.length > 0
        ? playerData.intProfExperience.map((record) => {
            return {
              years: record.years ? record.years.toString() : "--",
              countryName: record.countryName
                ? record.countryName.toString()
                : "--",
              league: record.league ? record.league.toString() : "--",
              clubName: record.clubName ? record.clubName.toString() : "--",
              contact: record.contact ? record.contact.toString() : "--",
              phone: record.phone ? record.phone.toString() : "--",
            };
          })
        : [],
    columnStyles: Array(6).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const gLeagueExperience = {
    title: "G League Experience",
    headerNames: [
      {
        title: "G League Year",
        field: "years",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Team",
        field: "team",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Team Contact",
        field: "contact",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Team Contact Phone",
        field: "phone",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      playerData && playerData?.gLeagueExperience?.length > 0
        ? playerData.gLeagueExperience.map((record) => {
            return {
              years: record.years ? record.years.toString() : "--",
              team: record.team ? record.team.toString() : "--",
              contact: record.contact ? record.contact.toString() : "--",
              phone: record.phone ? record.phone.toString() : "--",
            };
          })
        : [],
    columnStyles: Array(4).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const nationalIntExp = {
    title: "National/International Team Experience",
    headerNames: [
      {
        title: "International Experience Year",
        field: "expYear",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "International Experience Country",
        field: "countryName",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "International Experience",
        field: "experience",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      playerData && playerData?.nationalIntExp?.length > 0
        ? playerData.nationalIntExp.map((record) => {
            return {
              expYear: record.expYear ? record.expYear.toString() : "--",
              countryName: record.countryName
                ? record.countryName.toString()
                : "--",
              experience: record.experience
                ? record.experience.toString()
                : "--",
            };
          })
        : [],
    columnStyles: Array(3).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const highSchoolEvents = {
    title: "High School Events",
    headerNames: [
      {
        title: "Event Name",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Year",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      getRawHighSchoolEventsData().length > 0
        ? getRawHighSchoolEventsData().map((record) => ({
            eventName: record.eventName ? record.eventName.toString() : "--",
            eventYear: record.eventYear ? record.eventYear.toString() : "--",
          }))
        : [],
    columnStyles: Array(2).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const rankingDetails = {
    title: "Rankings",
    headerNames: [
      {
        title: "Event Name",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data: [
      {
        ranking:
          playerData.ranking.length && playerData.ranking[0].rankYear
            ? playerData.ranking[0].rankYear
            : "--",
      },
    ],
    columnStyles: Array(2).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const eventRankingDetails = {
    title: "",
    headerNames: [
      {
        title: "Event Name",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Ranking",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      getRawRankigEventsData().length > 0
        ? getRawRankigEventsData().map((record) => ({
            eventName: record.eventName ? record.eventName.toString() : "--",
            ranking: record.ranking ? record.ranking.toString() : "--",
          }))
        : [],
    columnStyles: Array(2).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };
  return [
    combineDetails,
    playerDetails,
    agentDetails,
    collegeExprienceDetails,
    highSchoolDetails,
    aIUClubProgramDetails,
    internationalExprienceDetails,
    gLeagueExperience,
    nationalIntExp,
    highSchoolEvents,
    rankingDetails,
    eventRankingDetails,
  ];
};
